const mod = require('../bahabot.module.js')

mod.component('bbDashboardLayout', {
    templateUrl: 'tpl/layouts/dashboard.layout.html',
    bindings: {},
    controller: ["AuthService", "$location", "ThemeService", function(AuthService, $location, ThemeService) {
        var ctrl = this
        ctrl.menuOpen = false;

        ctrl.isDark = ThemeService.isDark

        ctrl.toggleTheme = function() {
            ThemeService.toggle()
            ctrl.isDark = ThemeService.isDark
        }

        ctrl.toggleMenu = function() {
            ctrl.menuOpen = !ctrl.menuOpen;
        }

        ctrl.logout = function() {
            AuthService.logout().then(() => {
                const target = new URL(location.href);
                target.pathname = "/login";
                target.searchParams.append("idpNotice", "logged_out");
                location.href = target.toString();
            })
        }

        ctrl.routeClasses = function(path) {
            const isActive = $location.path().startsWith(path);

            if (isActive) {
                return {
                    'bg-gray-200 dark:bg-slate-700': true
                }
            }

            return {
                'bg-gray-100 dark:bg-slate-900': true
            }
        }

        ctrl.go = function(path) {
            $location.path(path).hash(null);
        }
    }]
});